import { Injectable, Injector } from '@angular/core';
import { AuthService } from '../../auth/auth.service';
import { map, catchError } from 'rxjs/operators';
import { HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TokenInterceptorService {

  constructor(private injector: Injector) { }

  intercept(req, next) {
    try {
      const authService = this.injector.get(AuthService);
      if (!authService.loggedIn()) {
        return next.handle(req).pipe(
          map((event: HttpEvent<any>) => {
            if (event instanceof HttpResponse) {
            }
            return event;
          }),
          catchError((error: HttpErrorResponse) => {
            if (error.status === 401) { authService.logoutUser(); }
            return throwError(error);
          }));
      }
      const tokenizedReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${authService.getToken()}`,
        },
      });
      return next.handle(tokenizedReq).pipe(
        map((event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
          }
          return event;
        }),
        catchError((error: HttpErrorResponse) => {
          if (error.status === 401) { authService.logoutUser(); }
          return throwError(error);
        }));
    } catch (error) {
    }
  }
}
